import React, { useState } from "react";

const Projet = () => {
  const [selectedImg, setSelectedImg] = useState(null);

  const products = [
    { 
      id: 81, 
      img: "https://i.postimg.cc/c1YC6yH2/image.png",
      caption: "اللغة العربية"
    },
    { 
      id: 82, 
      img: "https://i.postimg.cc/Z5fKXJ7B/22.png",
      caption: "اللغة الفرنسية"
    },
    { 
      id: 83, 
      img: "https://i.postimg.cc/Y0ftR7LS/99.png",
      caption: "العلوم الاقتصادية"
    },
    { 
      id: 84, 
      img: "https://i.postimg.cc/G2vR3RQj/88.png",
      caption: "الحقوق"
    },
  ];

  return (
    <section className="shop">
      <h1 className="section-title"> تنظيم البحوث</h1>
      <div className="product-list">
        {products.map((product) => {
          const whatsappMessage = `مرحبا هل يمكني انا استفسر عن تنظيم البحوث  (${product.caption}).`;
          const whatsappLink = `https://wa.me/70163001?text=${encodeURIComponent(whatsappMessage)}`;

          return (
            <div key={product.id} className="product-box">
              <div className="img-box">
                <img 
                  src={product.img} 
                  alt={product.caption} 
                  onClick={() => setSelectedImg(product.img)} 
                />
              </div>

              {/* الكابشن */}
              <p className="product-caption">{product.caption}</p>
               <br/>
              <a 
                href={whatsappLink} 
                target="_blank" 
                rel="noopener noreferrer" 
                className="whatsapp-card"
              >
                <img 
                  src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg" 
                  alt="WhatsApp" 
                  width="25" 
                  height="25" 
                />
                <span>التواصل عبر الواتس اب</span>
              </a>
            </div>
          );
        })}
      </div>

      {/* نافذة تكبير الصورة */}
      {selectedImg && (
        <div className="popup" onClick={() => setSelectedImg(null)}>
          <span className="close">&times;</span>
          <img src={selectedImg} alt="Zoomed" className="popup-img" />
        </div>
      )}
    </section>
  );
};

export default Projet;
